import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { TimeTrackerViews } from '@macs-frontend/features/time-tracking/time/models/time-tracker-views';
import { CalendarEvent, CalendarEventTimesChangedEvent } from 'angular-calendar';
import { DOCUMENT } from '@angular/common';
import { AppBaseComponent } from '@macs-frontend/web';
import { InternalUser } from '@macs-frontend/features/human-resources/models/internal-user';
import { Tab } from '@macs-frontend/features/time-tracking/time/time.store';

@Component({
  selector: 'md-timetracker-calendar',
  templateUrl: 'calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimetrackingCalendarComponent
  extends AppBaseComponent
  implements AfterViewInit
{
  @Input() selectedUser?: InternalUser;
  @Input() hideAddEventButton = false;
  @Input() set view(value: TimeTrackerViews) {
    this.scrollToWorkingTimeRange(value);
    this._view = value;
  }
  get view(): TimeTrackerViews {
    return this._view;
  }
  @Input() selectedDate!: Date;
  @Input() calendarEvents: CalendarEvent[] = [];
  @Input() selectedDateCalendarEvents: CalendarEvent[] = [];
  @Input() tabs: Tab[] = [];
  @Input() formattedSelectedWeek = '';
  @Input() formattedSelectedMonth = '';
  @Input() dayOfWeekOfSelectedDay = '';
  @Input() formattedSelectedDateMonth = '';
  @Input() formattedSelectedYear = '';

  @Output()
  addNewEntry = new EventEmitter<Date | undefined>();
  @Output() updateTimeEntry = new EventEmitter<CalendarEvent>();
  @Output() closeCalendar = new EventEmitter<void>();
  @Output() eventTimesChanged = new EventEmitter<CalendarEventTimesChangedEvent>();
  @Output() changeView = new EventEmitter<TimeTrackerViews>();
  @Output() goNext = new EventEmitter<void>();
  @Output() goPrevious = new EventEmitter<void>();
  @Output() goTodayOrThisWeek = new EventEmitter<void>();

  readonly refresh = new Subject<void>();
  readonly TimeTrackerViews = TimeTrackerViews;

  private _view!: TimeTrackerViews;
  private readonly afterViewInitSubject$ = new Subject<void>();

  constructor(@Inject(DOCUMENT) private document: Document) {
    super();
  }

  days = [0, 1, 2, 3, 4, 5, 6].map(v => {
    const date = new Date();
    date.setDate(date.getDate() + v);
    return date;
  });

  ngAfterViewInit() {
    this.afterViewInitSubject$.next();
  }

  close(): void {
    this.closeCalendar.emit();
  }

  onEventClicked({
    event,
  }: {
    event: CalendarEvent;
    sourceEvent: MouseEvent | KeyboardEvent;
  }) {
    // const timeEntry = this.store.timeTracks.find(
    //   ({ uuid }) => (uuid as any) === e.event.id,
    // );
    this.updateTimeEntry.emit(event);
  }

  onHourSegmentClicked(event: { date: Date; sourceEvent: MouseEvent }) {
    this.addNewEntry.emit(event.date);
  }

  onEventTimesChanged(event: CalendarEventTimesChangedEvent) {
    this.eventTimesChanged.emit(event);
  }

  private scrollToWorkingTimeRange(view: TimeTrackerViews) {
    this.afterViewInitSubject$.pipe(this.takeUntilDestroy()).subscribe(() => {
      const targetElementIndex = view === TimeTrackerViews.DAY ? 9 : 18;
      const offset = (
        this.document.querySelectorAll('.cal-time')[targetElementIndex]?.parentNode as any
      )?.offsetTop;
      if (offset) {
        window.scrollTo(0, offset);
      }
    });
  }
}
